import { Component } from '@angular/core';
import { catchError, finalize, forkJoin, map, of, switchMap } from 'rxjs';
import { ToasterService } from '../../../../providers/toaster/toaster.service';
import { ConfomerService } from '../../../../providers/confomer/confomer.service';
import { RouterModule } from '@angular/router';
import { CommonStaffApiServiceService } from '../../common-staff-api-service.service';
import { StaffCommonFormModalComponent } from "../../../../components/personnel-component/staff-common-form-modal/staff-common-form-modal.component";
import { PaginationComponent } from "../../../../components/pagination/pagination.component";
import { debounce } from 'lodash';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from "../../../../providers/loader.component";
import { FilterBaseAccessService } from '../../../../auth/filterbase-access';
import { CommonModule } from '@angular/common';
import { exportToCsv, exportToExcel, exportToPdf, parseCsvToObjects, type ExportColumn } from '../../utils/personnel-import-export';

@Component({
  selector: 'app-staff-list',
  standalone: true,
  imports: [StaffCommonFormModalComponent, RouterModule, PaginationComponent, FormsModule, LoaderComponent, CommonModule],
  templateUrl: './staff-list.component.html',
  styleUrl: './staff-list.component.css'
})
export class StaffListComponent {
  // check access variables
  staff_import_export = false;
  create_staff = false; 
  view_staff = false;
  list_staff = false;
  edit_staff = false;
  delete_staff = false;

formType: 'new' | 'edit' = 'new'
  staffId: number | string | null = null
  isMoaldalOpen = false
  staffList: any[] = []

  paginationData: any = {}
  currentPage: any
  searchStr: string = '';
  isFetching: boolean = false
  private readonly exportColumns: ExportColumn[] = [
    { key: 'name', label: 'Name' },
    { key: 'mobile', label: 'Mobile' },
    { key: 'email', label: 'Email' },
    { key: 'department', label: 'Department' }
  ];
  constructor(access:FilterBaseAccessService,private staffApiService: CommonStaffApiServiceService, private toasterService: ToasterService, private conformer: ConfomerService,) {

    this.staff_import_export = access.checkaccessforfiltersandactions('staff import export');
    this.create_staff = access.checkaccessforfiltersandactions('create staff');
    this.view_staff = access.checkaccessforfiltersandactions('view staff');
    this.list_staff = access.checkaccessforfiltersandactions('staff list');
    this.edit_staff = access.checkaccessforfiltersandactions('edit staff');
    this.delete_staff = access.checkaccessforfiltersandactions('delete staff');
  }

  ngOnInit() {
    this.getData()
  }

  getData() {
    this.isFetching = true;
    this.staffApiService.getStaffList('STF', this.currentPage,this.searchStr)
    .pipe(
      finalize(() => {
        this.isFetching = false;
      }))
    .subscribe({
      next: (res: any) => {
        if (res.status == 'success') {
          this.staffList = res?.data ?? [];
          this.paginationData = res?.pagination ?? {};
        } else {
          this.toasterService.setToaster('error', 'Error', res.message ?? 'Failed to fetch HOD list');
          this.staffList = [];
        }

      },
      error: (err) => {
        console.error('HTTP error:', err);
      }
    })
  }

  search = debounce(() => {
    this.getData();
  }, 300);


  async deletestaff(id: any) {
    if (!id) {
      return
    }

    const confirmer = await this.conformer.Open('Delete Student Profile!', 'Are you sure you want to delete this student profile')
    if (confirmer) {
      this.staffApiService.deleteStaff(id).pipe(
        finalize(() => {
          this.getData()
        })
      ).subscribe({
        next: (res: any) => {
          if (res.status == 'success') {
            this.toasterService.setToaster('success', 'Success', res.message ?? 'Student deleted successfully');
          }
        },
        error: (err) => {
          console.error('HTTP error:', err);
        }
      })
    }

  }



  showStaffFormModal(type: 'new' | 'edit', staffId?: number | string | null) {
    this.formType = type
    this.staffId = staffId || null
    setTimeout(() => {
      this.isMoaldalOpen = true;
    }, 100);
  }

  emitedData(data: any) {
    console.log(data)
    this.isMoaldalOpen = false;
    this.staffId = null;
    this.formType = 'new';
    this.getData();
  }

    pageChange(e: any) {
    this.currentPage = e;
    this.getData();
  }

  private loadStaffExportRows(roleId: string, search?: string) {
    return this.staffApiService.getStaffList(roleId, 1, search).pipe(
      switchMap((res: any) => {
        const rows = Array.isArray(res?.data) ? res.data : [];
        const pagination = res?.pagination ?? {};
        const lastPage = Number(pagination?.last_page ?? 0) || ((Number(pagination?.total ?? 0) > 0 && Number(pagination?.per_page ?? 0) > 0)
          ? Math.ceil(Number(pagination.total) / Number(pagination.per_page))
          : 0);
        if (lastPage <= 1) {
          return of(rows);
        }
        const pageRequests = [];
        for (let page = 2; page <= lastPage; page += 1) {
          pageRequests.push(
            this.staffApiService.getStaffList(roleId, page, search).pipe(
              map((pageRes: any) => Array.isArray(pageRes?.data) ? pageRes.data : []),
              catchError(() => of([]))
            )
          );
        }
        return forkJoin(pageRequests).pipe(
          map((pages: any[]) => rows.concat(...pages))
        );
      })
    );
  }

  exportData(type: 'csv' | 'excel' | 'pdf') {
    this.loadStaffExportRows('STF', this.searchStr || undefined).subscribe((rows: any[]) => {
      if (!rows?.length) {
        this.toasterService.setToaster('error', 'Export', 'No staff data available to export.');
        return;
      }
      const filenameBase = 'staff-list';
      if (type === 'pdf') {
        exportToPdf(rows, this.exportColumns, 'Staff List');
        return;
      }
      if (type === 'excel') {
        exportToExcel(rows, this.exportColumns, `${filenameBase}.xls`);
        return;
      }
      exportToCsv(rows, this.exportColumns, `${filenameBase}.csv`);
    });
  }

  handleImportFile(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) {
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      const rows = parseCsvToObjects(String(reader.result ?? ''));
      if (!rows.length) {
        this.toasterService.setToaster('error', 'Import', 'No valid rows found in CSV.');
        return;
      }
      const requests = rows.map(row => {
        const payload = { ...row, role: 'STF', role_id: 'STF' };
        return this.staffApiService.createStaffProfile(payload).pipe(
          map(() => ({ ok: true })),
          catchError(() => of({ ok: false }))
        );
      });
      forkJoin(requests).subscribe(results => {
        const successCount = results.filter(result => result.ok).length;
        const failedCount = results.length - successCount;
        if (successCount) {
          this.getData();
        }
        if (failedCount) {
          this.toasterService.setToaster('warning', 'Import', `${successCount} imported, ${failedCount} failed.`);
        } else {
          this.toasterService.setToaster('success', 'Import', `${successCount} staff imported successfully.`);
        }
      });
    };
    reader.readAsText(file);
    input.value = '';
  }
}
